// "Abbonati a SurvMaps": come per l'abbonamento OmniSurv, prima del Checkout
// l'utente accetta Termini di Servizio e informativa privacy, e l'accettazione
// viene registrata su OmniSurv (/billing/tos-acceptance).

import React, { useState } from "react";
import { Button, Check, Dialog } from "./ui";
import { useToast } from "./Toast";
import { startSubscription } from "../lib/docs";
import { authHeaders } from "../lib/omnisurv";
import proGif from "../assets/survmaps-pro.gif";

// Stesse versioni del modale di OmniSurv (ui_kits/workflow-canvas/HQPanel.jsx).
const TOS_VERSION = "1.0";
const PRIVACY_VERSION = "2026-09-16";

export default function SubscribeButton({ auth, block }) {
  const toast = useToast();
  const [open, setOpen] = useState(false);
  const [tosOk, setTosOk] = useState(false);
  const [privacyOk, setPrivacyOk] = useState(false);
  const [busy, setBusy] = useState(false);

  const accetta = async () => {
    setBusy(true);
    try {
      await fetch("/billing/tos-acceptance", {
        method: "POST",
        headers: { "Content-Type": "application/json", ...authHeaders(auth.token) },
        body: JSON.stringify({ tos_version: TOS_VERSION, privacy_version: PRIVACY_VERSION }),
      });
    } catch {
      // come in OmniSurv: il log dell'accettazione non blocca il pagamento
    }
    const err = await startSubscription(auth.token);
    if (err) {
      toast.error(err);
      setBusy(false);
    }
  };

  return (
    <>
      <Button block={block} onClick={() => setOpen(true)}>Abbonati a SurvMaps</Button>
      {open && (
        <Dialog
          title="Abbonamento SurvMaps"
          onClose={() => setOpen(false)}
          footer={(
            <>
              <Button busy={busy} disabled={!tosOk || !privacyOk} onClick={accetta}>Vai al pagamento</Button>
              <Button variant="ghost" onClick={() => setOpen(false)}>Annulla</Button>
            </>
          )}
        >
          <img
            src={proGif}
            alt="Disegna l'area, descrivi l'intervento, ottieni il documento con le norme pertinenti"
            style={{ width: "100%", borderRadius: "var(--r-sm)", border: "1px solid var(--border-hair)", display: "block" }}
          />
          <p className="sm-panel-text">
            L'abbonamento SurvMaps si aggiunge al tuo account OmniSurv{auth.email && <> ({auth.email})</>} e sblocca
            i comuni per abbonati e il Documento intervento. È un servizio SaaS: <b>non costituisce prestazione
            professionale</b> e i suoi output vanno sempre verificati dal tecnico incaricato.
          </p>
          <Check checked={tosOk} onChange={(e) => setTosOk(e.target.checked)}>
            <span>
              Ho letto e accetto i <a style={{ color: "var(--c-blue-bright)" }} href="/termsofservice/" target="_blank" rel="noopener noreferrer">Termini
              di Servizio (v{TOS_VERSION})</a>, in particolare le clausole su natura del servizio, esclusioni di garanzia,
              limitazione di responsabilità e foro competente (artt. 1341 e 1342 c.c.).
            </span>
          </Check>
          <Check checked={privacyOk} onChange={(e) => setPrivacyOk(e.target.checked)}>
            <span>
              Ho letto l'<a style={{ color: "var(--c-blue-bright)" }} href="/privacypolicy/" target="_blank" rel="noopener noreferrer">informativa
              privacy</a>.
            </span>
          </Check>
        </Dialog>
      )}
    </>
  );
}
